import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { faUndo, faEye, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import CreatableSelect from "react-select/creatable";
import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from "react-select";

import Table from "./CloseDealTable";

import * as Yup from "yup";
import { type } from "jquery";
import { getUserType } from "../../utils/index";

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

var tableCounter = 0;
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class AcquisitionReport extends React.Component {
  groupId = { value: "" };
  state = {
    assetsList: [],
    asset_type: [],
    redirect: false,
    id: undefined,
    counter: 0,
    initialValues: {
      asset_type: "",
      asset_name: "",
    },
    gridColumns: [],
  };

  componentDidMount() { }


  componentDidUpdate() { }

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

  }

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/close-deal/fetch-deal-details?asset_type=` +
        this.state.initialValues.asset_type +
        `&asset_name=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            asset_name: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  // -----------------------------------
  getAssetsListByAsset = (asset_type) => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/close-deal/get-asset-list?asset_type=` +
      asset_type,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // --------------------------------------------

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);
    if (actionMeta == "change_type") {
      this.state.initialValues.asset_type = newValue.target.value;

      this.setState({});
      this.getAssetsListByAsset(newValue.target.value);

    }
    else if (actionMeta == "change_asset_name") {

      this.state.initialValues.asset_name = newValue.value;
      this.state.initialValues.asset_name = newValue.label;
      this.setState({});
    }
  }

  handleChangeAsset = (newValue, actionMeta) => {
    this.state.initialValues.assetName = newValue.label;
    this.state.initialValues.assetId = newValue.value;
    this.setState({});
    console.group("Value Changed");
    this.asset = newValue.value;
    if (!isNaN(this.asset)) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-sub-assets?asset_id=` +
        this.asset,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            subAssets: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
    console.log(this.asset, "ddd");

    console.groupEnd();
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/client-profile" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Reports</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">
                  Lease Report -{" "}
                  Valuation
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {

            console.log("calll..")
            if (!this.validator.allValid()) {
              this.validator.showMessages();
              return false;
            }
            console.log("calll.. 123")
            var form_config = this.state.initialValues;
            var counter = this.state.counter + 1;
            form_config['type'] = 'valuation'
            this.setState({ formConfig: form_config });
            var prm = Object.entries(form_config)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");
            this.state.formResponseData = [];
            var headers = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN"),
            };
            this.setState({ "counter": counter });
            // fetch(
            //   `${apiUrl.apiUrl.url}/close-deal/fetch-deal-details?` + prm,
            //   { headers }
            // )
            //   .then((response) => {
            //     return response.json();
            //   })
            //   .then((data) => {
            //     //this.setState({  });
            //     tableCounter = 0;
            //     this.setState({
            //       formResponseData: data.data,
            //       monthsArr: data.monthsArr,
            //     });
            //     this.setState({ counter: counter });
            //     this.setState({
            //       exportUrl:
            //         `${apiUrl.apiUrl.url}/close-deal/fetch-deal-details?close-deal-export=true&` +
            //         prm,
            //     });
            //   })
            //   .catch((error) => {
            //     console.log(error);
            //   });

            form_config = undefined;
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off">
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      <div className="newGridSectionInner">
                        <label>Asset Type</label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="asset_type"
                            onChange={(e) => {
                              this.valueChange(e, "change_type");
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="Warehouse" label="Warehouse" />
                            <option value="Office" label="Office" />
                            <option value="Retail" label="Retail" />
                            <option value="Industry" label="Industry" />
                          </Field>
                          <ErrorMessage
                            name="asset_type"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="asset_name"
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_name");
                            }}
                            value={{
                              label: this.state.initialValues.asset_name,
                              value: this.state.initialValues.asset_name,
                            }}
                            options={this.state.assetsList.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="asset_name"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="add_button">
                        View
                      </button>
                      <button type="reset" className="reset_button">
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>

        <Table
          key={this.state.counter}
          columns={this.state.gridColumns}
          formConfig={this.state.formConfig}
          fetchUrl={apiUrl.apiUrl.url + "/close-deal/fetch-deal-details?"}
        />
      </>
    );
  }
}
export default withRouter(AcquisitionReport);